import { connect } from 'react-redux';
import { List } from 'immutable';
import 'react-widgets/lib/less/react-widgets.less';

import { Edit as DictEdit, mapDispatchToProps } from '../../simple/Edit';

import { REF_NAME, REF_PATH, NAME } from './Const';

class Edit extends DictEdit {
  constructor(props) {
    super(props);
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }
}

export default connect((state, props) =>
  ({
    saving: state.getIn(['allaround', 'saving'], false),
    refObject: state
      .getIn(['references', 'simple', REF_PATH], new List())
      .find(r => r.get('id') == props.params.refId),
  }),
mapDispatchToProps(REF_NAME, REF_PATH),
)(Edit);
